import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { formatNumber } from "../../../common/Misc";
import CustomTooltip from "../../../common/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileDownload } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { toast } from "react-toastify";
import { defaultBaseUrl } from "../../../../APIConfig/Interceptor";

const ExpandSubContractorDetails = ({ expandData }) => {
  const handleDownload = async (value) => {
    try {
      const response = await axios.get(`${value}`, {
        responseType: "blob",
      });
      const fileData = response.data;
      const url = window.URL.createObjectURL(new Blob([fileData]));

      var a = document.createElement("a");
      a.href = url;
      var extention = value.split(".");
      var file = value.split("/");
      a.setAttribute(
        "download",
        file[file.length - 1] || "document" + extention
      );
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (e) {
      toast.error("File does not exist.");
    }
  };

  const expandDataGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: expandData[i]?.id,
        contract_number: expandData[i]?.contract_number
          ? expandData[i]?.contract_number
          : "-",
        contract_value: expandData[i]?.contract_value
          ? expandData[i]?.contract_value
          : "-",
        contract_value_exc: expandData[i]?.contract_value_exc
          ? expandData[i]?.contract_value_exc
          : "-",
        retention_percentage: expandData[i]?.retention_percentage
          ? `${expandData[i]?.retention_percentage}%`
          : "0%",
        retention_value: expandData[i]?.retention_amount
          ? expandData[i]?.retention_amount
          : "0.00",
        pta_closing_balance: expandData[i]?.closing_balance_pta
          ? formatNumber(Number(expandData[i]?.closing_balance_pta))
          : "-",
        rta_closing_balance: expandData[i]?.closing_balance_rta
          ? formatNumber(Number(expandData[i]?.closing_balance_rta))
          : "-",
        action: (
          <>
            {expandData[i]?.contract_file && (
              <CustomTooltip message={"Download"}>
                <span>
                  <FontAwesomeIcon
                    onClick={() =>
                      expandData[i]?.contract_file?.includes(defaultBaseUrl())
                        ? handleDownload(expandData[i]?.contract_file)
                        : window.open(expandData[i]?.contract_file, "_blank")
                    }
                    icon={faFileDownload}
                    size="1x"
                    data-toggle="modal"
                    data-target="#deleteAccount"
                  />
                </span>
              </CustomTooltip>
            )}
          </>
        ),
      });
    }
    return items;
  };
  const subExapndData = expandDataGenerator(expandData?.length);

  const columns = [
    {
      dataField: "contract_number",
      text: "Contract / Agreement Number",
      style: { width: "15%" },
    },
    {
      dataField: "contract_value_exc",
      text: "Contract Value (Ex. GST)",
      style: { width: "15%" },
    },
    {
      dataField: "contract_value",
      text: "Contract Value (Inc. GST)",
      style: { width: "15%" },
    },
    {
      dataField: "retention_percentage",
      text: "Retention Percentage",
      style: { width: "15%" },
    },
    {
      dataField: "retention_value",
      text: "Retention Value",
      style: { width: "15%" },
    },
    {
      dataField: "pta_closing_balance",
      text: "Total Net Payment from PTA",
    },
    {
      dataField: "rta_closing_balance",
      text: "RTA Closing Balance",
    },
    {
      dataField: "action",
      text: "Action",
      align: "center",
      headerAlign: "center",
    },
  ];

  return (
    <>
      <div className="content-details">
        <div className="custom-table journal-expand-table">
          <BootstrapTable
            keyField="key"
            data={subExapndData}
            columns={columns}
            noDataIndication="No Data Found"
          />
        </div>
      </div>
    </>
  );
};

export default ExpandSubContractorDetails;
